import { createAction } from '@reduxjs/toolkit';
import { OrgCreateInfo } from '../../types';

import { withPayloadType } from 'utils';

export const signupOrgStart = createAction(
  'SIGN_UP_ORG::START',
  withPayloadType<OrgCreateInfo>(),
);
